export const environment = {
    production: false,
    api: {
        host_path: "/backoffice-api/api/v1"
    },
    keycloak: {
        url: '/idp',
        realm: 'quelix',
        clientId: 'quelix-console',
    }
};